export const REVIEW_WORKFLOW_LAUNCH_DATE = new Date('2026-05-20T00:00:00.000Z');

const curriculumCreatedAtMs = (curriculum) => {
  const createdAt = curriculum?.createdAt;
  if (!createdAt) return null;
  if (typeof createdAt.toDate === 'function') {
    const date = createdAt.toDate();
    return date instanceof Date && !Number.isNaN(date.getTime()) ? date.getTime() : null;
  }
  if (typeof createdAt.toMillis === 'function') {
    const millis = Number(createdAt.toMillis());
    return Number.isFinite(millis) ? millis : null;
  }
  if (createdAt instanceof Date) {
    return Number.isNaN(createdAt.getTime()) ? null : createdAt.getTime();
  }
  return null;
};

export const isCurriculumAssignable = (curriculum) => {
  const status = String(curriculum?.status || '').trim();
  if (status === 'approved') return true;
  if (status !== 'ready') return false;
  const createdAtMs = curriculumCreatedAtMs(curriculum);
  if (!Number.isFinite(createdAtMs)) return false;
  return createdAtMs < REVIEW_WORKFLOW_LAUNCH_DATE.getTime();
};
